import { MeasureToFetchForSummary } from '@mv-submodules/inplant-plantanalysis-fe-iblu/functions/influx/getChartInfluxData'

const engineTorqueDensifierMeasuresToFetch: MeasureToFetchForSummary[] = [
  {
    type: 'summary',
    measureId: 'vDecSpeedTorque',
    measureSlug: 'decSpeedTorque',
  },
  {
    type: 'summary',
    measureId: 'vDecUptime',
    measureSlug: 'decUptime',
  },
  {
    type: 'summary',
    measureId: 'vDecMeanScrewSpeed',
    measureSlug: 'decMeanScrewSpeed',
  },
]

export { engineTorqueDensifierMeasuresToFetch }
